import React, {useEffect, useState} from 'react'

const Upload = ({setFiles, files, fileInputs, fileInputValues}) => {
  const toBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })

  const filesList = async files => {
    let multipileFiles = []
    for (var i = 0; i < files.length; i++) {
      let file = files[i]
      multipileFiles.push(await toBase64(file))
    }
    return multipileFiles
  }

  const handleUpload = async (i, e) => {
    let file = await filesList(e.target.files)
    fileInputValues[i] = file[0]
    setFiles(fileInputValues)
  }

  return (
    <>
      {fileInputs.map((e, idx) => {
        return (
          <input
            type="file"
            accept=".png, .jpeg, .jpg, .doc, .docx, .pdf, .xls, .xlsx, .csv, .mp4, .mp3, .txt"
            name="myfile"
            id={idx}
            onChange={e => handleUpload(idx, e)}
            style={{marginTop: 5}}
          />
        )
      })}
    </>
  )
}

export default Upload
